import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Space,
  Modal,
  Skeleton,
  Alert,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import DatePicker from "@general/datePicker";
import { degrees } from "@staticData/user/profile";
import UploadFile from "@general/UploadFile";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import ResultMessage from "@general/resultMessage";

const UPDATEPROFILE = gql`
  mutation UpdateProfile($updateProfileInput: UpdateProfileInput!) {
    updateProfile(updateProfileInput: $updateProfileInput)
  }
`;
const PROFILEDATA = gql`
  query {
    getProfile {
      name
      fatherName
      mobile
      nationalIdCardNo
      address
      birthDate
      gender
      birthCertificateNo
      degree
      expertise
      nationalIdCardImg
      birthCertificateImg
      profileImg
      confirmStatus
      confirmMessage
      otherDocs {
        docName
        docImg
      }
    }
  }
`;
function Profile() {
  const [error, setError] = useState(null);
  const [initialData, setInitialData] = useState({});
  const [refetch, setRefetch] = useState(0);
  const [form] = Form.useForm();

  useEffect(() => {
    getProfilelData();
  }, [refetch]);

  const [getProfilelData, profileData] = useLazyQuery(PROFILEDATA, {
    fetchPolicy: "no-cache",
    onCompleted({ getProfile }) {
      const profileData = {
        ...getProfile,
        birthDate: getProfile?.birthDate && moment(getProfile?.birthDate),
      };
      form.setFieldsValue(profileData);
      const { confirmMessage, confirmStatus } = getProfile;
      setInitialData({ confirmMessage, confirmStatus });
    },
  });

  const [runUpdateProfile, updateProfile] = useMutation(UPDATEPROFILE, {
    onCompleted(data) {
      Modal.success({
        title: "متشکریم",
        content: "اطلاعات پروفایل شما ارسال شد.",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => setRefetch(refetch + 1)
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  const doUpdateProfile = (updateProfileInput) => {
    runUpdateProfile({
      variables: { updateProfileInput },
    });
  };
  const { confirmMessage, confirmStatus } = initialData;

  const { TextArea } = Input;

  if (profileData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if(confirmStatus === "PENDING")
   return (
    <Alert
      message="اطلاعات پروفایل شما در حال بررسی است."
      type="info"
      banner
      style={{ width: "100%", marginBottom: "30px" }}
    />
  );
  return (
    <>
      {(confirmStatus === "SUCCESS" ||
        confirmStatus === "ERROR") && (
          <ResultMessage
            confirmMessage={confirmMessage}
            confirmStatus={confirmStatus}
          />
        )}
      <Form
        layout="vertical"
        onFinish={doUpdateProfile}
        form={form}
        disabled={confirmStatus === "SUCCESS"}
      >
        <Row gutter={15}>
          <Col xs={24} md={12}>
            <Row gutter={15}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="name"
                  id="name"
                  label="نام و نام خانوادگی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input
                    disabled={confirmStatus === "SUCCESS"}
                    className="form-input"
                    placeholder={"نام و نام خانوادگی"}
                  />
                </Form.Item>

                <Form.Item
                  name="nationalIdCardNo"
                  label="کد ملی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد ملی خود خود را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "لطفا کدملی را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="کد ملی" />
                </Form.Item>

                <Form.Item
                  name="birthCertificateNo"
                  label="شماره شناسنامه"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شماره شناسنامه خود خود را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا شماره شناسنامه را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="شماره شناسنامه" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                  <Form.Item
                  name="fatherName"
                  id="fatherName"
                  label="نام پدر"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام پدر خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input
                    disabled={confirmStatus === "SUCCESS"}
                    className="form-input"
                    placeholder={"نام پدر"}
                  />
                </Form.Item>
                <Form.Item
                  name="gender"
                  label="جنسیت"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا جنسیت خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select
                    placeholder="جنسیت"
                    style={{ width: 120 }}
                    allowClear
                    options={[
                      {
                        value: "FEMALE",
                        label: "خانم",
                      },
                      {
                        value: "MALE",
                        label: "آقا",
                      },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  label="تاریخ تولد"
                  name="birthDate"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <DatePicker
                    showToday={false}
                    format="YYYY/MM/DD"
                    className="rtl"
                    placeholder="تاریخ تولد"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  label="آدرس محل سکونت"
                  name="address"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <Input.TextArea
                    rows={2}
                    placeholder="آدرس محل سکونت"
                    className="profile-address-textarea"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} md={12}>
            <Row gutter={15}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="degree"
                  label="تحصیلات"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا تحصیلات خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select placeholder="تحصیلات" allowClear options={degrees} />
                </Form.Item>

                <Form.Item
                  name="birthCertificateImg"
                  label="تصویر شناسنامه"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر شناسنامه خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile square />
                </Form.Item>
                <Form.Item
                  name="profileImg"
                  label="تصویر پروفایل"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر پروفایل خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile crop square />
                </Form.Item>
             
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="expertise"
                  label="حوزه فعالیت"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا حوزه فعالیت خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <TextArea placeholder="حوزه فعالیت" autoSize />
                </Form.Item>
                <Form.Item
                  name="nationalIdCardImg"
                  label="تصویر کارت ملی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر کارت ملی خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile square />
                </Form.Item>
                
             
              </Col>
              <Col span={24}>
                <Form.Item
                  name="otherDocs"
                  label="مدارک دیگر"
                  validateStatus={error && "error"}
                >
                  <Form.List name="otherDocs">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Space
                            key={key}
                            style={{
                              display: "flex",
                              marginBottom: 8,
                            }}
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "docName"]}
                              rules={[
                                {
                                  required: true,
                                  message: "لطفا عنوان فایل را وارد کنید!",
                                },
                              ]}
                            >
                              <Input placeholder="عنوان" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "docImg"]}
                              rules={[
                                {
                                  required: true,
                                  message: "این فیلد ضروری است!",
                                },
                              ]}
                            >
                              <UploadFile square />
                            </Form.Item>
                            {confirmStatus !== "SUCCESS" && (
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                              />
                            )}
                          </Space>
                        ))}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            افزودن
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Button
          type="primary"
          htmlType="submit"
          loading={updateProfile.loading && true}
        >
          ارسال
        </Button>
      </Form>
    </>
  );
}

export default Profile;
